/** Stripe's hosted checkout for the optional "buy me a coffee" support button.
 *  No keys and no backend involved — it just opens in a new tab. Used by both
 *  the home footer and the grown-up menu, so it lives in one place. */
export const COFFEE_URL = "https://buy.stripe.com/5kQ7sE4pQdjc2JGfrG8Zq00";
